type VisibleFieldMeta = {
  isBookingVisible?: boolean;
};

function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "string") return value.trim() === "";
  if (typeof value === "object") {
    const keys = Object.keys(value);
    if (keys.length === 0) return true;
    if ("id" in value) {
      const idVal = (value as { id?: unknown }).id;
      return (
        idVal === null || idVal === undefined || String(idVal).trim() === ""
      );
    }
    return false;
  }
  return false;
}

function isEmptyRecord(input: Record<string, unknown>): boolean {
  for (const key of Object.keys(input)) {
    if (!isEmptyValue(input[key])) {
      return false;
    }
  }
  return true;
}

export function getVisibleInsuredEntityFieldNames(
  visibleBookingFields: Record<string, unknown> | undefined,
  formName: string,
): string[] {
  const section = visibleBookingFields?.[formName];
  if (!section || typeof section !== "object") {
    return [];
  }

  const names = new Set<string>();

  const collectFromFieldMap = (fieldMap: unknown) => {
    if (!fieldMap || typeof fieldMap !== "object") {
      return;
    }
    for (const [fieldName, meta] of Object.entries(fieldMap)) {
      if (
        meta &&
        typeof meta === "object" &&
        "isBookingVisible" in meta &&
        (meta as VisibleFieldMeta).isBookingVisible === true
      ) {
        names.add(fieldName);
      }
    }
  };

  if (Array.isArray(section)) {
    section.forEach(collectFromFieldMap);
    return [...names];
  }

  collectFromFieldMap(section);
  for (const value of Object.values(section)) {
    if (value && typeof value === "object" && !("isBookingVisible" in value)) {
      collectFromFieldMap(value);
    }
  }

  return [...names];
}

export function isEmptyInsuredEntityRecord(
  entity: Record<string, unknown> | undefined | null,
  visibleFieldNames?: string[],
): boolean {
  if (!entity || typeof entity !== "object") {
    return true;
  }

  const valuesToCheck =
    visibleFieldNames && visibleFieldNames.length > 0
      ? Object.fromEntries(
          visibleFieldNames.map((fieldName) => [fieldName, entity[fieldName]]),
        )
      : entity;

  return isEmptyRecord(valuesToCheck);
}

export function filterNonEmptyInsuredEntityRecords<
  T extends Record<string, unknown>,
>(entities: T[], visibleFieldNames: string[]): T[] {
  return entities.filter(
    (entity) => !isEmptyInsuredEntityRecord(entity, visibleFieldNames),
  );
}
